import { getAgreementListApi } from '@/utils/api/common'
import { getZhenYunAgreementListApi } from '@/utils/api/zhenyun-agreement'
import Axios from 'axios'
export default {
  data() {
    return {
      agreementIds: [20, 40, 50],
      zhenyunAgreementIds:[140]
    }
  },
  methods: {
    // 获取嗨搜相关服务协议
    async getAgreementList() {
      try {
        // 如果vuex有服务协议，不用重新请求
        if (this.agreementList && this.agreementList.length) {
          this.agreements = this.agreementList
          this.agreements.forEach((ele) => {
            if(!ele.html) this.loadHtml(ele)
          })
          return
        }
        // vuex中没有存，重新请求
        const res = await getAgreementListApi()
        if (res.rspResult.bizCode === 200) {
          const list = res.rspListData.list || []
          this.agreements = []
          this.agreementIds.forEach(ele => {
            const findItem = list.find((item) => {
              return item.type === ele
            })
            if(findItem) this.agreements.push(findItem)
          })
          const requests = this.agreements.map((ele) => {
            return this.loadHtml(ele)
          })
          Promise.all(requests).then((res) => {
            this.SET_AGREEMENT_LIST(this.agreements)
          })
        } else {
          this.$message.error('系统繁忙，请稍后再试')
        }
      } catch (err) {
        console.error(
          '❌ ~ file: order-submission.vue:137 ~ getAgreementList ~ err:',
          err
        )
        this.$message.error('系统繁忙，请稍后再试')
      }
    },


    // 获取甄云授权书
    async getZhenyunAgreementList(channelType,refresh = false) {
      try {
        // 如果vuex有服务协议，不用重新请求
        if (this.zhenyunAgreementList && this.zhenyunAgreementList.length && !refresh) {
          this.zhenyunAgreements = this.zhenyunAgreementList
          this.zhenyunAgreements.forEach((ele) => {
            if(!ele.html) this.loadHtml(ele)
          })
          return
        }
        // vuex中没有存，重新请求
        const res = await getZhenYunAgreementListApi()
        if (res.rspResult.bizCode === 200) {
          const list = res.rspListData.list || []
          this.zhenyunAgreements = []
          this.zhenyunAgreementIds.forEach(ele => {
            const findItem = list.find((item) => {
              return item.type === ele && item.channel === channelType
            })
            if(findItem) this.zhenyunAgreements.push(findItem)
          })
          const requests = this.zhenyunAgreements.map((ele) => {
            return this.loadHtml(ele)
          })
          Promise.all(requests).then((res) => {
            this.SET_ZHENYUN_AGREEMENT_LIST(this.zhenyunAgreements)
            console.log(this.zhenyunAgreements,'this.zhenyunAgreements')
          })
        } else {
          this.$message.error('系统繁忙，请稍后再试')
        }
      } catch (err) {
        console.error(
          '❌ ~ file: order-submission.vue:137 ~ getAgreementList ~ err:',
          err
        )
        this.$message.error('系统繁忙，请稍后再试')
      }
    },

    // 点击单个协议
    agreementClick(val, index) {
      // 如果服务协议没有解析到内容，抛提示
      if(!this.agreements || !this.agreements.length || this.agreements.some(ele => !ele.html)) {
        return this.$message.error("系统繁忙，请稍后再试")
      }
      this.agreementIndex = index
      this.serviceAgreementShow = true
    },

    // 解析html文件
    async loadHtml(val) {
      // 使用axios等方法获取html文件内容
      await Axios.get(val.url).then((response) => {
        // 创建一个DOM解析器
        const parser = new DOMParser()
        // 将HTML内容解析为DOM节点
        const doc = parser.parseFromString(response.data, 'text/html')
        // 提取<body>标记内的内容
        val.html = doc.querySelector('body').innerHTML
      }).catch(err => {
        this.$message.error('系统繁忙，请稍后再试')
        console.error("❌ ~ file: order-submission.vue:182 ~ awaitAxios.get ~ err:", err)
        val.html = ''
      })
    },

    /**
     * @description: 同意条款回调
     * @param {*} agreed 是否点击了同意
     */
    serviceAgreementClose(agreed) {
      this.rnewCheckBox = false
      this.$nextTick(() => {
        this.rnewCheckBox = true
      })
      if (agreed) {
        this.checked = true
        this.consentTime = new Date().getTime()
      }
      this.serviceAgreementShow = false
    },

    // 当点击checkbox时
    checkboxChange(val) {
      // 如果服务协议没有解析到内容，抛提示
      if(!this.agreements || !this.agreements.length || this.agreements.some(ele => !ele.html)) {
        return this.$message.error("系统繁忙，请稍后再试")
      }
      if (val) {
        this.agreementIndex = undefined
        this.serviceAgreementShow = true
      } else {
        this.checked = false
      }
    },
  }
}